import React, { FunctionComponent, useContext, useState } from "react";
import { ButtonProps, CommandBarButton } from "sprint-common-web";

import { MergeEpisodeVersionsRequest } from "../../../../api/MergeEpisodeVersionsRequest";
import { useAssetsManageTvSeriesApi } from "../../../../api/useAssetsManageTvSeriesApi";
import { EpisodeVersionListContext } from "../context/EpisodeVersionListProvider";
import { EpisodeVersionListingItem } from "../EpisodeVersionListingItem";
import { MergeEpisodeVersionsConfirmationModal } from "./MergeEpisodeVersionsConfirmationModal";

export const MergeEpisodeVersionsCommandBarButton: FunctionComponent<ButtonProps> = (props: ButtonProps) => {
    const {
        versionsToMerge,
        selectedTvSeries,
        selectedEpisode,
        selectedSeason,
        setEpisodeVersionAsMerged,
        clearVersionsToMerge
    } = useContext(EpisodeVersionListContext);

    const { mergeEpisodeVersions } = useAssetsManageTvSeriesApi();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const isMergeButtonDisabled = () => {
        return versionsToMerge.length < 2;
    };

    const [target, orphan] = versionsToMerge;

    const handleMergeButtonClick = async (): Promise<void> => {
        setIsLoading(true);

        await mergeEpisodeVersions(
            selectedTvSeries.id,
            createMergeRequest(versionsToMerge, selectedSeason.id, selectedEpisode.id)
        );
        setEpisodeVersionAsMerged(orphan.id, target.id);

        closeModal();
        clearVersionsToMerge();
        setIsLoading(false);
    };

    return (
        <>
            <CommandBarButton
                onClick={openModal}
                text="Merge"
                icon="Merge"
                disabled={isMergeButtonDisabled() || props.disabled}
            />
            <MergeEpisodeVersionsConfirmationModal
                tvSeriesId={selectedTvSeries.id}
                episodeId={selectedEpisode.id}
                targetVersion={target}
                orphanedVersion={orphan}
                isOpen={isModalOpen}
                isConfirmationDisabled={isLoading}
                onConfirm={handleMergeButtonClick}
                onDismiss={closeModal}
            />
        </>
    );
};

const createMergeRequest = (
    versionItems: EpisodeVersionListingItem[],
    seasonId: string,
    episodeId: string
): MergeEpisodeVersionsRequest => {
    return {
        targetVersionId: versionItems[0].id,
        orphanedVersionId: versionItems[1].id,
        episodeId,
        seasonId
    };
};
